import { render, staticRenderFns } from "./ShowModalityAddress.vue?vue&type=template&id=1e8decc6&scoped=true"
import script from "./ShowModalityAddress.vue?vue&type=script&lang=js"
export * from "./ShowModalityAddress.vue?vue&type=script&lang=js"
import style0 from "./ShowModalityAddress.vue?vue&type=style&index=0&id=1e8decc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8decc6",
  null
  
)

export default component.exports